/** @jsxImportSource @emotion/react */
import UI from "@mile-meeting/mile-ui";
import Modal from "react-modal";
import { CancelBtnContainer, TitleHeader } from "./index.styles";
import PermissionTable from "./permission-table";
import styled from "@emotion/styled";
const modalStyle = {
  content: {
    height: "calc(100% - 80px)",
    top: "50%",
    boxSize: "border-box",
    left: "50%",
    right: "auto",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    width: "966px",
    padding: "0",
    maxHeight: 800,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

const Container = styled.div`
  padding: 60px 48px 48px 48px;
  height: 100%;
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
`;

export type TPermission = {
  mainMenu: string;
  subMenu: string;
  owner: boolean;
  superAdmin: boolean;
  policyAdmin: boolean;
  securityAdmin: boolean;
  staff: boolean;
};

type Props = {
  modalIsOpen?: boolean;
  closeModal?: () => void;
  onClick?: () => void;
};

export default function PermissionTableModal(props: Props) {
  const { modalIsOpen = false, closeModal = () => {} } = props;

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <CancelBtnContainer>
        <UI.IconButton.Normal
          type="primary"
          icon="x"
          size={20}
          color="var(--alias-color-label-normal)"
          onClick={closeModal}
        />
      </CancelBtnContainer>
      <Container>
        <TitleHeader>
          <div className="title">
            <UI.Icon name="people" size={32} color="var(--alias-color-label-neutral)" />
            <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-neutral)">
              권한별 세부사항
            </UI.Typography>
            <UI.ButtonGroups.Text
              title="권한 상세 안내 가이드"
              type="secondary"
              size="small"
              prefixIcon="question"
              showPrefixIcon
              onClick={() =>
                window.open(
                  "https://mile-corporation.notion.site/12ea222a9c1b81889932eda482323803#1dfa222a9c1b80a7b13fd55a7cfc68af"
                )
              }
              styles={{
                container: {
                  marginLeft: "auto",
                },
              }}
            />
          </div>
          <div className="annotation">
            <UI.Icon name="info" size={20} color="var(--alias-color-label-assistive)" />
            <UI.Typography type="label01" fontStyle="bold" color="var(--alias-color-label-alternative)">
              회의실 민원 관리는 담당자로 지정된 모든 멤버가 권한과 상관없이 접근할 수 있습니다.
            </UI.Typography>
          </div>
        </TitleHeader>
        <PermissionTable />
      </Container>
    </Modal>
  );
}
